<template>
  <div class="device tab-wrap">
    <ul v-if="isUnfold" class="tab-container asideOut">
      <li>
        <div class="tab-chouti">
          <i class="iconfont icon-caidan-dakai anniu" @click="folding"></i>
        </div>
      </li>
      <li
        v-for="tab in tabs"
        :key="tab.id"
        :class="{active: activeTab === tab.id}"
        class="tab"
        @click="activeTab=tab.id"
      >
        <div class="tab-item" v-if="tab.id == 'device'">
          <i class="iconfont icon-device"></i>
          <p>{{tab.label}}</p>
        </div>
        <div class="tab-item" v-if="tab.id == 'datalogger'">
          <i class="iconfont icon-shucaiqi"></i>
          <p>{{tab.label}}</p>
        </div>
      </li>
    </ul>
    <ul v-else class="tab-container asideIn">
      <li>
        <div class="tab-chouti">
          <i class="iconfont icon-caidan-shousuo anniu" @click="folding"></i>
        </div>
      </li>
      <li
        v-for="chouTab in tabs"
        :key="chouTab.id"
        :class="{active: activeTab === chouTab.id}"
        class="chouTab"
        @click="activeTab=chouTab.id"
      >
        <el-dropdown
          v-if="chouTab.id == 'device'"
          @command="handleDeviceCommand"
          placement="right"
        >
          <el-button v-if="chouTab.id == 'device'" class="operation">
            <i class="iconfont iconChouti icon-device"></i>
          </el-button>
          <el-dropdown-menu class="activeTabGroup" slot="dropdown">
            <el-dropdown-item :class="{active: activeTab === chouTab.id}" class="activeTabGroupItem" command="device">{{chouTab.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          v-if="chouTab.id == 'datalogger'"
          @command="handleDeviceCommand"
          placement="right"
        >
          <el-button v-if="chouTab.id == 'datalogger'" class="operation">
            <i class="iconfont iconChouti icon-shucaiqi"></i>
          </el-button>
          <el-dropdown-menu class="activeTabGroup" @click="activeTab=group" slot="dropdown">
            <el-dropdown-item :class="{active: activeTab === chouTab.id}" class="activeTabGroupItem" command="datalogger">{{chouTab.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb
          separator="/"
          class="head-nav"
        >
        <el-breadcrumb-item :to="{ path: '/home' }">{{$t('menu.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="activeTab == 'device'">{{$t('device.deviceList')}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="activeTab == 'datalogger'">{{$t('device.dataloggerList')}}</el-breadcrumb-item>
      </el-breadcrumb>
      <component :is="activeTab" class="tab-content"></component>
    </div> -->
    <component :is="activeTab" class="tab-content"></component>
  </div>
</template>
<script>
import device from './device'
import datalogger from './datalogger'
export default {
  components: {
    device,
    datalogger
  },
  data() {
    return {
      isUnfold: true,
      activeTab: 'device',
      tabs: [{
        id: 'device',
        label: this.$t('device.deviceList'),
      },{
        id: 'datalogger',
        label: this.$t('device.dataloggerList'),
      }]
    }
  },
    methods: {
    handleDeviceCommand(command) {
      switch (command) {
        case "device":
          this.activeTab = "device";
          break;
        case "datalogger":
          this.activeTab = "datalogger";
          break;
        default:
          break;
      }
    },
    folding() {
      if (this.isUnfold) {
        this.isUnfold = !this.isUnfold;
      } else {
        this.isUnfold = !this.isUnfold;
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");
.activeTabGroup {
  background: @siderbarColor;
  margin-left: 30px;
}
.activeTabGroupItem {
  // background: #1890ff;
  color: #ffffff;
  border: none;
  margin: 5px 0;
  &:not(:last-child) {
    border-bottom: none;
  }
  &.active{
    background: @themeColor;
  }
  &:hover,
  &:focus {
    background: @themeColor;
    color: #ffffff;
  }
}
.iconfont {
  display: inline-block;
  font-size: 24px;
}
.asideOut {
  width: 256px !important;
  transition: all 0.3s linear 0s;
}
.asideIn {
  width: 80px !important;
  transition: all 0.3s linear 0s;
}
.anniu {
  font-size: 28px;
  color: #ffffff;
  cursor: pointer;
    &:hover,
  &:focus {
    color: @themeColor;
  }
}
</style>
